import { gql } from '@apollo/client'
// MASTER LIST QUERIES
export const GET_ROUTE_STATUS = gql`
    query BoatRouteStatus($code: String) {
        boatRouteStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_ROUTE_TRIP_STATUS = gql`
    query BoatRouteTripStatus {
        boatRouteTripStatus {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_ROUTE_TYPE = gql`
    query RouteType($code: String) {
        routeType(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_BOAT_SEAT_LAYOUT = gql`
    query BoatSeatLayout($boatSeatLayoutId: String) {
        boatSeatLayout(id: $boatSeatLayoutId) {
            layout_id
            layout_key
            num_rows
            num_columns
            description {
                en
                ar
            }
        }
    }
`
export const GET_TRIP_TYPE = gql`
    query TripType($code: String) {
        tripType(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_MASTER_ROUTE_LIST = gql`
    query getMasterBoatRoute(
        $statusCode: String
        $routeType: String
        $routeName: String
        $masterRouteId: String
        $page: PageInput!
    ) {
        getMasterBoatRoute(
            status_code: $statusCode
            route_type: $routeType
            route_name: $routeName
            master_route_id: $masterRouteId
            page: $page
        ) {
            code
            success
            message
            total_count
            master_boat_routes {
                master_route_id
                route_name {
                    en
                    ar
                }
                route_type {
                    code
                    description {
                        en
                        ar
                    }
                }
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                waypoints {
                    location_id
                    location {
                        id
                        name {
                            en
                            ar
                        }
                        address {
                            unit_no
                            road_no
                            block_no
                            contact
                            area
                            landmark
                            country_code
                        }
                        geo {
                            lat
                            lng
                        }
                        contact {
                            email
                            phone_number
                        }
                        country_details {
                            country_code
                            country
                            country_ar
                            is_gcc
                        }
                    }
                    stop_number
                    status {
                        description {
                            en
                            ar
                        }
                        code
                    }
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`
export const GET_MASTER_BOAT_ROUTE_WITH_TRIP_DETAILS = gql`
    query GetMasterBoatRoute(
        $page: PageInput!
        $statusCode: String
        $routeName: String
        $masterRouteId: String
        $routeType: String
    ) {
        getMasterBoatRoute(
            page: $page
            status_code: $statusCode
            route_name: $routeName
            master_route_id: $masterRouteId
            route_type: $routeType
        ) {
            code
            success
            message
            total_count

            master_boat_routes {
                master_route_id
                route_name {
                    en
                    ar
                }
                route_type
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                waypoints {
                    location_id
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    stop_number
                    status {
                        code
                        description {
                            en
                        }
                    }
                }
            }
        }
    }
`
// BoatRouteWaypointStatus
export const GET_ROUTE_WAYPOINT_STATUS = gql`
    query BoatRouteWaypointStatus($code: String) {
        boatRouteWaypointStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_CAPTAIN_SHIFT_SCHEDULE_STATUS = gql`
    query CaptainShiftScheduleStatus($code: String) {
        captainShiftScheduleStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_BOAT_ROUTE_ASSIGNMENT_STATUS = gql`
    query BoatRouteAssignmentStatus($code: String) {
        boatRouteAssignmentStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

// Route List Queries
export const GET_BOAT_ROUTE_LIST = gql`
    query GetBoatRoute($page: PageInput!, $routeId: String, $routeName: String, $statusCode: String) {
        getBoatRoute(page: $page, route_id: $routeId, route_name: $routeName, status_code: $statusCode) {
            code
            success
            message
            total_count
            boat_routes {
                is_charter
                route_id
                route_name {
                    en
                    ar
                }
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                boat_id
                boat {
                    name {
                        en
                    }
                }
                days_of_week
                master_route {
                    master_route_id
                    route_name {
                        en
                        ar
                    }
                    status_code
                    waypoints {
                        location_id
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                        stop_number
                        status {
                            code
                            description {
                                en
                                ar
                            }
                        }
                    }
                }
                seat_layout_id
                active_seat_layout {
                    layout_id
                    layout_key
                    num_rows
                    num_columns
                    description {
                        en
                        ar
                    }
                }
                trip_type_code
                trip_type {
                    code
                    description {
                        en
                        ar
                    }
                }
                trip_tag
                editable {
                    waypoints
                }
            }
        }
    }
`
export const GET_BOAT_ROUTE = gql`
    query GetBoatRoute($page: PageInput!, $statusCode: String, $routeName: String, $routeId: String) {
        getBoatRoute(page: $page, status_code: $statusCode, route_name: $routeName, route_id: $routeId) {
            code
            success
            message
            total_count
            boat_routes {
                route_id
                service_fee_config {
                    cabin_upgrade_fee
                }
            }
        }
    }
`
export const GET_BOAT_ROUTE_WITH_TRIP_DETAILS = gql`
    query GetBoatRouteWithTripDetails($page: PageInput!, $routeId: String, $routeName: String, $statusCode: String) {
        getBoatRoute(page: $page, route_id: $routeId, route_name: $routeName, status_code: $statusCode) {
            code
            success
            message
            total_count
            boat_routes {
                charter_route_price {
                    price_id
                    route_id
                    start_location_id
                    start_location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    end_location_id
                    end_location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    price {
                        boat_price
                        round_trip {
                            boat_price
                        }
                    }
                    currency
                }
                is_charter
                route_id
                route_name {
                    en
                    ar
                }
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                boat_id
                boat {
                    name {
                        en
                        ar
                    }
                }
                days_of_week
                master_route {
                    master_route_id
                    route_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    status_code
                    waypoints {
                        location_id
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                        stop_number
                        status {
                            code
                            description {
                                en
                                ar
                            }
                        }
                    }
                }
                seat_layout_id
                active_seat_layout {
                    layout_id
                    layout_key
                    num_rows
                    num_columns
                    description {
                        en
                        ar
                    }
                }
                trip_type_code
                trip_type {
                    code
                    description {
                        en
                        ar
                    }
                }
                trip_tag
                editable {
                    waypoints
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                route_trip {
                    trip_id
                    trip_name {
                        en
                        ar
                    }

                    route_id
                    start_time
                    end_time
                    schedule {
                        location_id
                        status_code
                        stop_number
                        arrival_time
                        departure_time
                        remarks
                        entry_allowed
                        exit_allowed
                    }
                    status {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    valid_to
                    valid_from
                }
                route_price {
                    price_id
                    route_id
                    start_location {
                        id
                        name {
                            en
                            ar
                        }
                    }

                    end_location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    price {
                        ADL
                        CHD
                        INF
                        SNR
                        round_trip {
                            ADL
                            CHD
                            INF
                            SNR
                        }
                    }
                    currency
                    seat_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                }
                weight_config {
                    luggage_policy {
                        extra_luggage_options_kg
                        max_extra_luggage_total_kg
                        __typename
                    }
                    special_items_limits {
                        strollers
                        wheelchairs
                        __typename
                    }
                }
            }
        }
    }
`
export const GET_BOAT_ROUTE_DETAILS = gql`
    query GetBoatRoute($page: PageInput!, $routeId: String, $routeName: String, $statusCode: String) {
        getBoatRoute(page: $page, route_id: $routeId, route_name: $routeName, status_code: $statusCode) {
            code
            success
            message
            total_count
            boat_routes {
            is_charter
                route_id
                route_name {
                    en
                    ar
                }
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                boat_id
                boat {
                    name {
                        en
                        ar
                    }
                }
                days_of_week
                master_route {
                    master_route_id
                    status_code
                    waypoints {
                        location_id
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                        stop_number
                        status {
                            code
                            description {
                                en
                                ar
                            }
                        }
                    }
                }
            }
        }
    }
`
export const GET_TRIP_INFO = gql`
    query GetBoatRouteTrip($tripId: NonEmptyString!) {
        getBoatRouteTrip(trip_id: $tripId) {
            code
            success
            message
            trip {
                is_trip_private
                trip_id
                trip_name {
                    en
                    ar
                }
                route_id
                route {
                    is_charter
                    route_id
                    route_name {
                        en
                        ar
                    }
                    master_route {
                        route_type {
                            code
                            description {
                                en
                                ar
                            }
                        }
                    }
                }
                start_time
                end_time
                schedule {
                    location_id
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    status_code
                    stop_number
                    arrival_time
                    departure_time
                    remarks
                    entry_allowed
                    exit_allowed
                    stop_chargeable
                }
                status {
                    code
                    description {
                        en
                    }
                }

                editable {
                    status
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                valid_to
                valid_from
                daypass_allowed
                daypass_id
                daypass {
                    name {
                        en
                        ar
                    }
                    description {
                        en
                        ar
                    }
                }
                reschedule_allowed
                is_trip_private
                return_trip_policy {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`
export const GET_CAPTAIN_SHIFT_SCHEDULE_LIST = gql`
    query GetCaptainShiftSchedule($page: PageInput!, $shiftScheduleFilter: CaptainShiftScheduleFilterInput) {
        getCaptainShiftSchedule(page: $page, shift_schedule_filter: $shiftScheduleFilter) {
            code
            success
            message
            total_count
            shift_schedules {
                shift_schedule_id
                captain {
                    id
                    user_info {
                        given_name
                        family_name
                    }
                    user_roles

                    is_active
                }
                route_id
                days_of_week
                start_time
                end_time
                valid_from
                valid_to
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`
export const GET_BOAT_ROUTE_ASSIGNMENT = gql`
    query GetBoatRouteAssignment($page: PageInput!, $assignmentFilter: BoatRouteAssignmentFilterInput) {
        getBoatRouteAssignment(page: $page, assignment_filter: $assignmentFilter) {
            code
            success
            message
            total_count
            route_assignments {
                assignment_id
                boat {
                    id
                    name {
                        en
                        ar
                    }
                }
                route_id
                start_date
                end_date
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`
export const GET_RETURN_POLICY = gql`
    query ReturnPolicy($code: String) {
        returnPolicy(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_ROUTE_TRIP_SCHEDULED_INFO = gql`
    query GetRouteTripScheduledInfo {
        getRouteTripScheduledInfo {
            code
            success
            message
            max_trip_date
        }
    }
`
